/**
 * Hashes a string using SHA-256 algorithm.
 * Used for encrypting sensitive identifiers before storing in localStorage.
 *
 * @param value - The string to hash
 * @returns A promise that resolves to the hex-encoded hash string
 */
export async function hashString(value: string): Promise<string> {
  // Encode the string as UTF-8
  const encoder = new TextEncoder();
  const data = encoder.encode(value);

  // Hash the data using SHA-256
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);

  // Convert the hash to a hex string
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('');

  return hashHex;
}

/**
 * Hashes a user's subId for safe storage in localStorage.
 * Returns an empty string if the input is empty or undefined.
 *
 * @param subId - The user's subId to hash
 * @returns A promise that resolves to the hashed subId or empty string
 */
export async function hashUserId(subId: string | undefined): Promise<string> {
  if (!subId) {
    return '';
  }
  return hashString(subId);
}
